import { render, staticRenderFns } from "./StaffLists.vue?vue&type=template&id=3cdcf2eb&scoped=true"
import script from "./StaffLists.vue?vue&type=script&lang=js"
export * from "./StaffLists.vue?vue&type=script&lang=js"
import style0 from "./StaffLists.vue?vue&type=style&index=0&id=3cdcf2eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdcf2eb",
  null
  
)

export default component.exports